import { useUI } from "state/UIContext";
import Img from "../Image";
import { useAppAssetsWithSrc } from "Theme/EVENTS_ASSETS";
import classNames from "classnames";
import { useOrgData } from "state/OrgDataContext";

/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const Logo = ({ className = "" }: { className?: string }) => {
  const { colorScheme } = useUI();
  const EVENT_ASSETS = useAppAssetsWithSrc();
  const { dataContent: EVENT_CONTENT } = useOrgData();

  let logoSrc = EVENT_ASSETS.logo.src;
  let logoFallbackSrc = EVENT_ASSETS.logo.fallbackSrc;

  if (colorScheme === "dark") {
    logoSrc = EVENT_ASSETS.logoDark.src || EVENT_ASSETS.logo.src;
    logoFallbackSrc =
      EVENT_ASSETS.logoDark.fallbackSrc || EVENT_ASSETS.logo.fallbackSrc;
  }

  // Config `logoHeight` wins. Numeric strings ("40") would be invalid CSS, so coerce to px.
  const rawLogoHeight = EVENT_CONTENT.logoHeight;
  const logoHeight =
    typeof rawLogoHeight === "string" && /^\d+(\.\d+)?$/.test(rawLogoHeight.trim())
      ? Number(rawLogoHeight)
      : rawLogoHeight;
  const hasLogoHeight = logoHeight !== undefined && logoHeight !== null && logoHeight !== "";

  return (
    <Img
      key={colorScheme}
      src={logoSrc || logoFallbackSrc}
      fallbackSrc={logoFallbackSrc}
      style={hasLogoHeight ? { height: logoHeight, width: "auto" } : undefined}
      // Call-site max-h-* caps only apply when config gives no height, otherwise they clamp it.
      className={classNames(!hasLogoHeight && className)}
    />
  );
};

export default Logo;
